<template>
    <div v-if="isVisibleVideoU" class="modal-overlay">
      <div class="modal-content">
        <h3 class="title">Nuevo video</h3>
        <form @submit.prevent="submitVideo">
          <div class="form-group">
            <label for="video_id">ID del Video</label>
            <input
              type="text"
              id="video_id"
              v-model="video_id"
              placeholder="Zone ID"
              disabled
            />
          </div>
  
          <div class="form-group">
            <label for="video">Nuevo Video</label>
            <textarea
              id="video"
              v-model="video"
              placeholder="Agrega el link del video aquí"
              rows="3"
            ></textarea>
          </div>
  
          <div class="text-center" v-if="video">
            <iframe
              v-if="isEmbedUrl"
              :src="embedUrl"
              frameborder="0"
              allowfullscreen
              style="margin-top: 10px; width: 100%; height: 250px;"
            ></iframe>
            <p v-else class="text-red">
              Este enlace no es válido o no es compatible con los servicios de video (YouTube, Vimeo).
            </p>
          </div>
  
          <div style="display: flex; justify-content: flex-end">
            <button
              type="submit"
              :disabled="dataSent"
              :class="{ 'btn-disabled': dataSent }"
            >
              Guardar cambios
            </button>
            <button type="button" @click="closeModal">Cerrar</button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import {
    showErrorToast,
    showInfoToast,
    showSuccessToast,
  } from "@/kernel/alerts";
  import { saveVideoLink } from "../services/sections-service";
  
  export default {
    props: {
      isVisibleVideoU: {
        type: Boolean,
        required: true,
      },
      videoSection: {
        type: String,
        default: "",
      },
      videoId: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        video_id: "",
        video: "",
        dataSent: false,
      };
    },
    watch: {
      videoSection(newVal) {
        if (newVal) {
          this.video_id = newVal;
        }
      },
    },
    computed: {
      isEmbedUrl() {
        return !!this.embedUrl;
      },
      embedUrl() {
        // YouTube
        if (this.video.includes("youtube.com") || this.video.includes("youtu.be")) {
          const id = this.extractYouTubeId(this.video);
          return id ? `https://www.youtube.com/embed/${id}` : null;
        }
        // Vimeo
        if (this.video.includes("vimeo.com")) {
          const id = this.extractVimeoId(this.video);
          return id ? `https://player.vimeo.com/video/${id}` : null;
        }

        // Twitch
        if (this.video.includes("twitch.tv")) {
          const id = this.extractTwitchId(this.video);
          return id ? `https://player.twitch.tv/?video=${id}` : null;
        }

        // Dailymotion
        if (this.video.includes("dailymotion.com")) {
          const id = this.extractDailymotionId(this.video);
          return id ? `https://www.dailymotion.com/embed/video/${id}` : null;
        }

        // Facebook
        if (this.video.includes("facebook.com")) {
          const id = this.extractFacebookId(this.video);
          return id ? `https://www.facebook.com/embed/${id}` : null;
        }

        // Instagram
        if (this.video.includes("instagram.com")) {
          const id = this.extractInstagramId(this.video);
          return id ? `https://www.instagram.com/embed/${id}` : null;
        }

        // TikTok
        if (this.video.includes("tiktok.com")) {
          const id = this.extractTikTokId(this.video);
          return id ? `https://www.tiktok.com/embed/${id}` : null;
        }
        return null;
      },
    },
    methods: {
      extractYouTubeId(url) {
        const regex = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^\s&?/]+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      },
      extractVimeoId(url) {
        const regex = /vimeo\.com\/(?:video\/)?(\d+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      },
      extractTwitchId(url) {
        const regex = /twitch\.tv\/video\/(\d+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      },
      extractDailymotionId(url) {
        const regex = /dailymotion\.com\/video\/(\d+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      },
      extractFacebookId(url) {
        const regex = /facebook\.com\/video\/(\d+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      },
      extractInstagramId(url) {
        const regex = /instagram\.com\/video\/(\d+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      },
      extractTikTokId(url) {
        const regex = /tiktok\.com\/video\/(\d+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      },
      closeModal() {
        this.$emit("update:visible", false);
        this.video = "";
      },
      async submitVideo() {
        this.dataSent = true;
        showInfoToast("Guardando enlace del video...");
  
        if (!this.video || !this.video_id || !this.isEmbedUrl) {
          this.dataSent = false;
          showErrorToast("Por favor, ingresa un enlace válido de YouTube, Vimeo, Twitch, Dailymotion, Facebook, Instagram o TikTok.");
          return;
        }
  
        try {
          const formData = {
            video_link: this.video,
            video_id: this.video_id,
          };
  
          const result = await saveVideoLink(formData);
          if (result.status === 200) {
            showSuccessToast("Video actualizado correctamente.");
            this.$emit("update:files");
            this.closeModal();
          }
        } catch (error) {
          console.error("Error en la solicitud:", error);
          showErrorToast("Ocurrió un error al guardar el video.");
        } finally {
          this.dataSent = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-width: 100%;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
  }
  
  input,
  textarea {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }
  
  button {
    padding: 10px 15px;
    margin-top: 10px;
    cursor: pointer;
    background-color: orange;
    color: white;
    border: none;
    border-radius: 16px;
  }
  
  button[type="submit"]:hover {
    background-color: yellowgreen;
  }
  
  button[type="button"] {
    margin-left: 16px;
    background-color: darkgray;
  }
  
  button[type="button"]:hover {
    background-color: gray;
  }
  
  .title {
    margin-top: 0;
    color: orange;
  }
  
  .text-red {
    color: red;
    font-weight: bold;
    margin-top: 8px;
  }
  
  .btn-disabled {
    background-color: #ccc !important;
    cursor: not-allowed;
    opacity: 0.6;
  }
  </style>
  